<template>
  <div class="space-y-6 p-6">
    <div class="backdrop-blur-sm py-3 glass-card-lite">
            <div class="mx-auto px-6">
                <nav class="flex space-x-1">
                    <button
                        v-for="tab in tabs"
                        :key="tab.id"
                        @click="activeTab = tab.id"
                        :class="[
                        'px-6 py-4 font-bold transition-all duration-200 flex items-center space-x-2 rounded-md border border-white glass-card',
                        activeTab === tab.id
                            ? 'bg-transparent text-fuchsia-500'
                            : 'text-gray-400 hover:bg-slate-800/30 hover:text-fuchsia-500  bg-transparent'
                        ]"
                    >
                        <component :is="tab.icon" class="w-4 h-4" />
                        <span>{{ tab.label }}</span>
                    </button>
                </nav>
            </div>
        </div>

    <!-- Content Area -->
    <div class="mx-auto">
      <component :is="currentComponent" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, h } from 'vue';
import OverviewView from './OverviewView.vue';
import UsersView from './UsersView.vue';
import WhitelistView from './WhitelistView.vue';
import ApiKeyView from './ApiKeyView.vue';
import FirmwareView from './FirmwareView.vue';
import OrganisationView from './OrganisationView.vue';
import { 
  Grid, 
  Users2Icon, 
  Shield, 
  KeyIcon, 
  CpuIcon,
  Group
} from 'lucide-vue-next';


const tabs = [
  { id: 'overview', label: 'OVERVIEW', icon: Grid },
  { id: 'users', label: 'USERS', icon: Users2Icon },
  { id: 'whitelist', label: 'WHITELIST', icon: Shield },
  { id: 'apikey', label: 'API KEY', icon: KeyIcon },
  { id: 'firmware', label: 'FIRMWARE', icon: CpuIcon },
  { id: 'organisation', label: 'ORGANISATION', icon: Group }
];

const activeTab = ref('overview');

const currentComponent = computed(() => {
  const components = {
    overview: OverviewView,
    users: UsersView,
    whitelist: WhitelistView,
    apikey: ApiKeyView,
    firmware: FirmwareView,
    organisation: OrganisationView
  };
  return components[activeTab.value];
});
</script>